import styled, { keyframes } from 'styled-components';
import { radius, Stack } from '@libertify/ui';
import { BotIcon } from './BotIcon';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
`;

const StyledDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: currentColor;
  border-radius: ${radius.circle};
  animation: ${bounce} 1.4s infinite ease-in-out;

  &:nth-child(1) {
    animation-delay: -0.32s;
  }
  &:nth-child(2) {
    animation-delay: -0.16s;
  }
`;

const StyledBubble = styled.div`
  display: inline-flex;
  gap: 4px;
  padding: 8px 12px;
  background-color: #f0f0f0;
  border-radius: ${radius.box}px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const TypingIndicator = () => {
  return (
    <Stack direction="horizontal" align="center" gap="sm">
      <BotIcon />
      <StyledBubble>
        <StyledDot />
        <StyledDot />
        <StyledDot />
      </StyledBubble>
    </Stack>
  );
};
